import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from "lodash";
import swal from 'sweetalert2';
import axios from "axios/index";
import {withRouter} from 'react-router-dom';
import InputMask from 'react-input-mask';

import urls from "../../../../utils/urls";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import validators from "../../../../utils/validators";
import translator from "../../../../utils/translations";
import { Spinner } from '../../../../components/Loading/Spinner';
import helpers from '../../../../utils/helpers';
import formatters from "../../../../utils/formatters";
import Datepicker from '../../../../components/Datepicker/datepicker';
import { reloadTrip } from '../../../../actions/trip_actions';

import TripProgrammingForm from './Done/TripProgrammingForm';


class TripDispatch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            canEdit: helpers.isUserProvider(this.props.user) || helpers.isUserReception(this.props.user),
            ajaxInProgress: false,
            trip: this.props.trip,
            products: false,
            product: '',
            load_datetime: '',
            provider_load_volume: '',
            provider_trip_receipt: '',
            provider_observations: ''
        }
    }

    componentDidMount() {
        this._fetchOptions();
    }

    _initializeHtml = () => {
        window.initializeCollapsible();
    };

    _fetchOptions = () => {
        const PRODUCTS_URL = `${urls.API_ROOT}/api/v1/product/`;
        axios.get(PRODUCTS_URL, tokenHeader())
            .then(response => {
                this.setState({
                    products: response.data.filter(p => p.trip_type === 'FE')
                }, this._initializeHtml);

            })
            .catch((error) => ajaxHandler(error));
    };

    _handleInput = (prop, value) => {

        // Custom validations
        if(prop === 'carrier_doc'){
            value = validators.cuit(value);
        }

        let numbers = ['provider_load_volume'];
        if(numbers.indexOf(prop) > -1){
            value = validators.number(value);
        }

        this.setState({[prop]: value});
    };

    _handleDateChange = (prop, value) => {
        this.setState({[prop]: value });
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let {load_datetime, provider_load_volume, provider_trip_receipt, provider_observations} = this.state;

        let data = {
            next_status: 'B0',
            load_datetime,
            provider_load_volume,
            provider_trip_receipt,
            provider_observations
        };

        const SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.trip.id}/`;
        axios.put(`${SHIPMENT_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Viaje actualizado',
            html: 'El despacho ha sido ingresado correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    }

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido crear el despacho',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    _goBack = () => {

        let excludedKeys = ['canEdit', 'ajaxInProgress', 'trip', 'products'];

        let data = _.omit(this.state, excludedKeys);
        let warning = false;
        Object.keys(data).forEach(key => {
            if (data[key] !== '') warning = true
        });

        if(warning){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/')
        }

    };

    render() {

        // Waiting for options
        if(!this.state.products){
            return (
                <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                    <Spinner />
                </div>
            );
        }

        if(!this.state.canEdit){
            return (
                <div className={"trip-section"}>

                    <div className={'trip-section-title'}>Despacho</div>
                    <div className={"row no-padding thin-row margin-top-10"}>
                        <div className={"col s12"}>
                            <div className={"waiting-continer valign-wrapper w100"}>
                                <p className={"w100 center"}>
                                    Esperando despacho del proveedor
                                    <br />
                                    <i className="material-icons">more_horiz</i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        // If there's an ajax call in progress or if user can not edit
        let disableButtons = this.state.ajaxInProgress;

        let date = new Date();
        let maxDate = new Date();
        // TODO - Review this in a few days from now 14/09/2018
        let minDate = new Date(date.setTime(date.getTime() - (24*60*60*1000*30)));

        let dispatchVolumeLabel = 'Cantidad despachada';

        if(this.state.trip && this.state.trip.product){
            dispatchVolumeLabel = `${_.capitalize(this.state.trip.product.origin_unit_of_measure)}. despachados ${this.state.trip.product.origin_density ? ` a ${formatters.floatFormat(this.state.trip.product.origin_density)}º` : ""}`;
        }

        return (
            <div>
                <TripProgrammingForm boxed={true} trip={this.state.trip} />
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Despacho</div>
                    <div className={"row no-padding thin-row trip-form"}>
                        <div className={"col s6 no-padding"}>
                            <div className={"row margin-top-10 thin-row"}>
                                <div className={"col s6 input-field"}>
                                    <label className="active">Producto</label>
                                    <p className={"field-p"}>{this.state.trip.product.name}</p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">{dispatchVolumeLabel}</label>
                                    <input placeholder={"Ingrese cantidad"} value={this.state.provider_load_volume}
                                           onChange={(ev) => this._handleInput('provider_load_volume', ev.target.value)}/>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col s6 input-field "}>
                                    <label className="active">Fecha de Carga</label>
                                    <Datepicker classname="input-grey" placeholder={"Ingrese fecha"}
                                                value={this.state.load_datetime} format={"YYYY-MM-DDTh:mm"}
                                                id="load_datetime" action={this._handleDateChange}
                                                max={maxDate} min={minDate}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Nro. Remito</label>
                                    <InputMask placeholder={"Ingrese nro remito"} value={this.state.provider_trip_receipt}
                                               mask={'9999-99999999'}
                                               onChange={(ev) => this._handleInput('provider_trip_receipt', ev.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={"col s6 no-padding"}>
                            <div className={"row margin-top-10 thin-row"}>
                                <div className={"col s12 input-field input-grey"}>
                                    <label className="active">Observaciones</label>
                                    <textarea
                                        className={"materialize-textarea dispatch-textarea"} rows={4}
                                        onChange={(ev) => this._handleInput('provider_observations', ev.target.value)}
                                        defaultValue={this.state.provider_observations}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._goBack}
                                className={`btn btn-shell-empty z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Volver
                        </button>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({reloadTrip}, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TripDispatch));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripDispatch.js